export default __webpack_public_path__ + "static/media/logout.a5148ef7.svg";